import { useEffect, useState } from 'react';
import { AppBar, Toolbar, Container, Box, Button, IconButton, Typography } from '@mui/material';
import { Logo, Menu as MenuIcon } from '../icons';
import { landingColors, landingFont } from './landingTheme';
import { NAV_ITEMS } from './landingContent';

const linkSx = (scrolled) => ({
  fontFamily: landingFont,
  fontWeight: 600,
  fontSize: '0.95rem',
  textTransform: 'none',
  color: scrolled ? landingColors.ink : 'rgba(255,255,255,0.85)',
  '&:hover': { color: landingColors.indigo, backgroundColor: 'transparent' },
});

export default function LandingNav({ isAuthenticated, onNavigate, onScrollToSection, onOpenMobileMenu }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const authed = typeof isAuthenticated === 'function' && isAuthenticated();

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: scrolled ? 'rgba(255,255,255,0.92)' : 'transparent',
        backdropFilter: scrolled ? 'saturate(180%) blur(12px)' : 'none',
        borderBottom: scrolled ? `1px solid ${landingColors.line}` : '1px solid transparent',
        transition: 'background-color 0.3s ease, border-color 0.3s ease',
        color: scrolled ? landingColors.ink : '#fff',
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, md: 4 } }}>
        <Toolbar disableGutters sx={{ minHeight: { xs: 64, md: 76 }, justifyContent: 'space-between' }}>
          <Box
            sx={{ display: 'flex', alignItems: 'center', gap: 1.25, cursor: 'pointer' }}
            onClick={() => onNavigate('/')}
          >
            <Logo size={34} variant={scrolled ? 'blue' : 'white'} />
            <Typography sx={{ fontFamily: landingFont, fontWeight: 800, fontSize: '1.2rem', letterSpacing: '-0.01em' }}>
              merchQRy
            </Typography>
          </Box>

          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1, alignItems: 'center' }}>
            {NAV_ITEMS.map((item) => (
              <Button key={item.id} disableRipple sx={linkSx(scrolled)} onClick={() => onScrollToSection(item.id)}>
                {item.label}
              </Button>
            ))}
          </Box>

          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1.5, alignItems: 'center' }}>
            <Button
              onClick={() => onNavigate(authed ? '/admin' : '/login')}
              sx={{ ...linkSx(scrolled), fontWeight: 700 }}
            >
              {authed ? 'Dashboard' : 'Login'}
            </Button>
            <Button
              onClick={() => onNavigate('/register')}
              variant="contained"
              disableElevation
              sx={{
                fontFamily: landingFont,
                textTransform: 'none',
                fontWeight: 700,
                borderRadius: '999px',
                px: 2.75,
                py: 1,
                backgroundColor: landingColors.indigo,
                '&:hover': { backgroundColor: landingColors.indigoStrong },
              }}
            >
              Get Started
            </Button>
          </Box>

          <IconButton
            onClick={onOpenMobileMenu}
            aria-label="Open menu"
            sx={{ display: { xs: 'flex', md: 'none' }, color: scrolled ? landingColors.ink : '#fff' }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
